export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7853.994c22ec.jpg";